export default {
	implemetationLevelsDropdown: (state) => {
		const items = [
			{
				text: 'Seleccionar nivel',
				value: ''
			},
			{
				text: 'Arriba de lo esperado',
				value: 1
			},
			{
				text: 'En lo esperado',
				value: 2
			},
			{
				text: 'Debajo de lo esperado',
				value: 3
			}
		];
		return items;
	},
	riskFactorDropdown: (state) => {
		const items = [
			{
				text: 'Seleccionar factor',
				value: ''
			},
			{
				text: 'Bajo',
				value: 1
			},
			{
				text: 'Medio',
				value: 2
			},
			{
				text: 'Alto',
				value: 3
			}
		];
		return items;
	},
	strategyFactorDropdown: (state) => {
		const items = [
			{
				text: 'Seleccionar factor',
				value: ''
			},
			{
				text: 'Conveniente',
				value: 1
			},
			{
				text: 'Necesario',
				value: 2
			},
			{
				text: 'Urgente',
				value: 3
			}
		];
		return items;
	}
};



// WEBPACK FOOTER //
// ./src/store/admin/getters.js